export function leafletMap() {
    /**
     * Store Locator - Leaflet Map Implementation
     *
     * Features:
     * - Custom map tiles (multiple style options)
     * - Custom marker icons
     * - Region filtering via tabs
     * - Store list with click-to-focus
     * - Search functionality
     * - Responsive design
     */

    (function () {
        'use strict';

        // =========================================================================
        // CONFIGURATION
        // =========================================================================

        const CONFIG = {
            // Map settings
            map: {
                defaultCenter: [39.0742, 21.8243],
                defaultZoom: 5,
                minZoom: 3,
                maxZoom: 18,
                zoomControl: false,
                // dragging: false,
                // tap: false,
                scrollWheelZoom: false, // Add this line
            },

            // Tile layer options - pick your style
            tiles: {
                // Clean, minimal style (CartoDB Positron)
                light: {
                    url: 'https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png',
                    attribution:
                        '<a href="https://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                },
            },

            // Select which tile style to use
            activeTileStyle: 'light',

            // Animation
            flyToDuration: 1.3,
            markerBounceHeight: 20,
        };

        // =========================================================================
        // STATE
        // =========================================================================

        let map = null;
        let markers = [];
        let markerLayer = null;
        let activeRegion = 'all';
        let activeStoreId = null;

        // =========================================================================
        // CUSTOM MARKER ICONS
        // =========================================================================

        /**
         * Create custom SVG marker icon
         * You can customize colors, size, and shape here
         */
        // FIX #3: Added storeId param so each marker gets unique clip-path IDs,
        // preventing cross-marker SVG clip-path conflicts in the DOM.
        function createMarkerIcon(isActive = false, storeId = 0) {
            const size = isActive ? 44 : 36;
            const uid = storeId;
            const svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${size}" height="${size}" viewBox="0 0 46.182 67.522">
            <defs>
                <clipPath id="clip-path-${uid}">
                <path id="Path_1386-${uid}" data-name="Path 1386" d="M0,23.483C0,38.217,17.572,62.658,22.031,67.118c1.057,1.056,1.046,1.065,2.115,0C28.613,62.65,46.18,38.106,46.18,23.483a23.09,23.09,0,1,0-46.18,0" transform="translate(0 -0.391)" fill="none"/>
                </clipPath>
                <clipPath id="clip-path-2-${uid}">
                <rect id="Rectangle_206-${uid}" data-name="Rectangle 206" width="28.669" height="21.284" fill="none"/>
                </clipPath>
                <clipPath id="clip-path-3-${uid}">
                <rect id="Rectangle_207-${uid}" data-name="Rectangle 207" width="28.674" height="21.296" fill="none"/>
                </clipPath>
            </defs>
            <g id="Group_722-${uid}" data-name="Group 722" transform="translate(100 -833.678)">
                <path id="Path_1382-${uid}" data-name="Path 1382" d="M46.182,23.482c0,14.624-17.569,39.165-22.034,43.632-1.07,1.069-1.059,1.059-2.115,0C17.572,62.659,0,38.218,0,23.482a23.091,23.091,0,0,1,46.182,0" transform="translate(-100 833.287)" fill="#e60020"/>
                <g id="Group_324-${uid}" data-name="Group 324" transform="translate(-100 833.678)">
                <g id="Group_323-${uid}" data-name="Group 323" clip-path="url(#clip-path-${uid})">
                    <g id="Group_319-${uid}" data-name="Group 319" transform="translate(10.166 -0.626)" opacity="0.8">
                    <g id="Group_318-${uid}" data-name="Group 318" transform="translate(0 0)">
                        <g id="Group_317-${uid}" data-name="Group 317" clip-path="url(#clip-path-2-${uid})">
                        <path id="Path_1383-${uid}" data-name="Path 1383" d="M7.076,13.025l0,0ZM34.981.014,12.271,9.993a19.169,19.169,0,0,0-5.151,2.993l-.04.037h0l.008,0c-.125.125-.178.184-.226.242v0h0a2.232,2.232,0,0,0-.176.228c-.01.013-.018.029-.027.043a2.021,2.021,0,0,0-.216.433l-.018.05c-.008.022-.013.043-.019.066s-.01.045-.016.066-.01.043-.014.064-.008.042-.011.064l-.008.066c0,.022,0,.046-.008.07l0,.059v.008l0,.058,0,.051,0,.022a.348.348,0,0,0,0,.058l.006.066.01.077a.355.355,0,0,0,.01.054c0,.022.01.043.013.066l.019.082.014.05c0,.022.013.045.019.066l.029.085a.4.4,0,0,0,.018.046c.008.022.018.045.027.066l.038.09.019.04.034.066c.018.034.035.067.054.1l.013.026c.014.024.029.046.045.07s.04.067.062.1l.014.022.05.07c.029.038.056.079.085.117s.04.05.059.075.064.077.1.115l0,0c.019.022.038.046.059.069.037.04.072.08.111.12l.066.067c.04.04.08.08.122.12l.069.064c.043.04.088.082.133.122l.051.043.069.059.1.08.026.019.127.1.077.058.018.013c.061.046.123.093.187.138l.037.026.011.008c.07.048.141.1.215.146l.027.018.01.006a12.655,12.655,0,0,0,2.963,1.394l7.665,2.394,7.114-3.12q1.079-.454,2-.937A15.659,15.659,0,0,0,32,14.681l0,0a10.331,10.331,0,0,0,1.024-1.139A9.1,9.1,0,0,0,34.4,11.027a9.976,9.976,0,0,0,.341-1.2,12.787,12.787,0,0,0,.272-2.73V0Z" transform="translate(-6.345 0)" fill="#fff"/>
                        </g>
                    </g>
                    </g>
                    <g id="Group_322-${uid}" data-name="Group 322" transform="translate(7.384 34.395)" opacity="0.8">
                    <g id="Group_321-${uid}" data-name="Group 321">
                        <g id="Group_320-${uid}" data-name="Group 320" clip-path="url(#clip-path-3-${uid})">
                        <path id="Path_1384-${uid}" data-name="Path 1384" d="M29.6,24.944l-.072-.032c-.175-.08-.351-.159-.53-.232-.026-.01-.051-.019-.077-.03-.28-.112-.567-.216-.854-.311l-7.638-2.48L13.285,24.99c-6.524,2.746-8.676,6.236-8.676,11.065v7.1L27.385,33.16a19.7,19.7,0,0,0,5.27-3.084c.032-.029.075-.069.115-.111,1.5-1.734-.5-3.773-3.172-5.021" transform="translate(-4.609 -21.858)" fill="#fff"/>
                        </g>
                    </g>
                    </g>
                    <path id="Path_1385-${uid}" data-name="Path 1385" d="M29.115,19.148,12.62,14a13.574,13.574,0,0,1-1.532-.6l-.011-.006c-.095-.043-.186-.088-.277-.133l-.032-.016-.252-.13-.045-.024-.231-.127-.054-.032c-.072-.042-.144-.083-.215-.127-.019-.011-.038-.024-.059-.035l-.2-.125c-.021-.014-.042-.029-.062-.042-.062-.042-.127-.083-.187-.125-.022-.016-.043-.032-.066-.046L9.223,12.3l-.069-.053c-.054-.04-.107-.082-.159-.123-.024-.018-.048-.037-.07-.056-.05-.04-.1-.08-.146-.122l-.071-.059-.135-.122c-.022-.022-.045-.043-.067-.064-.042-.04-.083-.082-.122-.122-.022-.022-.045-.045-.066-.067q-.058-.06-.111-.12c-.021-.024-.043-.046-.062-.07s-.066-.079-.1-.119-.04-.05-.059-.075-.058-.077-.085-.115l-.054-.079c-.026-.038-.05-.077-.074-.115s-.034-.054-.05-.082-.042-.075-.061-.114l-.043-.083c-.018-.038-.034-.075-.048-.114s-.026-.056-.037-.085-.026-.074-.037-.111-.019-.059-.027-.09-.018-.072-.026-.109-.014-.059-.019-.09-.01-.072-.013-.107-.008-.062-.01-.093,0-.069,0-.1,0-.064,0-.095.008-.067.011-.1.006-.066.011-.1.016-.064.022-.095.014-.069.024-.1.019-.051.029-.079a1.984,1.984,0,0,1,.216-.433c.013-.021.026-.043.04-.064l0,0,.01-.013,0,0q.065-.091.144-.183h0c.05-.056.1-.115.226-.242L8.1,8.162l-.143.125c-.058.053-.115.1-.173.155l0,0c-.082.075-.311.3-.311.3l-.006.006C4,11.959,4.631,18.112,4.631,18.112a8.828,8.828,0,0,0,6.563,9.011l16.883,5.488c.288.093.574.2.856.311.024.01.051.019.075.03.181.074.356.151.532.232l.072.032c2.666,1.248,4.667,3.288,3.171,5.021-.038.042-.083.082-.115.111l-.019.019c.085-.074.242-.213.242-.213,2.584-2.033,3.164-5.23,3.164-9.787,0-3.626-1.235-7.6-6.939-9.219" transform="translate(2.762 4.267)" fill="#fff"/>
                </g>
                </g>
            </g>
        </svg>
        `;

            return L.divIcon({
                className: 'sl-marker' + (isActive ? ' is-active' : ''),
                html: svgIcon,
                iconSize: [size, size + 8],
                iconAnchor: [size / 2, size + 8],
                popupAnchor: [0, -size],
            });
        }

        /**
         * Alternative: Use image-based icons
         * Uncomment this and update paths if you prefer image icons
         */
        /*
            function createMarkerIconImage(isActive = false) {
                const data = window.storeLocatorData || {};
                const iconUrl = isActive
                    ? (data.markerIconActive || '/assets/images/marker-active.png')
                    : (data.markerIcon || '/assets/images/marker.png');

                return L.icon({
                    iconUrl: iconUrl,
                    iconSize: isActive ? [44, 52] : [36, 44],
                    iconAnchor: isActive ? [22, 52] : [18, 44],
                    popupAnchor: [0, -44],
                });
            }
            */

        // =========================================================================
        // MAP INITIALIZATION
        // =========================================================================

        function initMap() {
            const mapContainer = document.getElementById('storeMap');
            if (!mapContainer) {
                console.error('Store Locator: Map container not found');
                return;
            }

            // Create map instance
            map = L.map('storeMap', {
                center: CONFIG.map.defaultCenter,
                zoom: CONFIG.map.defaultZoom,
                minZoom: CONFIG.map.minZoom,
                maxZoom: CONFIG.map.maxZoom,
                zoomControl: CONFIG.map.zoomControl,
                // dragging: CONFIG.map.dragging,
                // tap: CONFIG.map.tap,
                scrollWheelZoom: CONFIG.map.scrollWheelZoom,
            });

            // Add tile layer
            const tileConfig = CONFIG.tiles[CONFIG.activeTileStyle] || CONFIG.tiles.light;
            L.tileLayer(tileConfig.url, {
                // attribution: tileConfig.attribution,
                maxZoom: CONFIG.map.maxZoom,
            }).addTo(map);

            // Create marker layer group
            markerLayer = L.layerGroup().addTo(map);

            // Add markers
            addMarkers();
            // Fit bounds to show all markers
            fitMapToMarkers();
            // Setup custom controls
            setupMapControls();
        }

        // =========================================================================
        // MARKERS
        // =========================================================================

        function addMarkers() {
            const data = window.storeLocatorData || {};
            const stores = data.stores || [];

            // Clear existing markers
            markerLayer.clearLayers();
            markers = [];

            stores.forEach((store) => {
                if (!store.lat || !store.lng) return;

                // FIX #3: Pass store.id so the marker gets unique SVG clip-path IDs.
                const marker = L.marker([store.lat, store.lng], {
                    icon: createMarkerIcon(false, store.id),
                    storeId: store.id,
                    storeData: store,
                });

                // Popup content
                marker.bindPopup(createPopupContent(store), {
                    maxWidth: 300,
                    className: 'sl-popup',
                });

                // Marker events
                marker.on('click', () => {
                    setActiveStore(store.id);
                });

                marker.on('popupclose', () => {
                    if (activeStoreId === store.id) {
                        setActiveStore(null);
                    }
                });

                markers.push(marker);
                markerLayer.addLayer(marker);
            });
        }

        function createPopupContent(store) {
            return `
            <div class="sl-popup__content">
                <div class="sl-popup__body">
                    <h4 class="sl-popup__title">${store.title}</h4>
                    <div class="sl-popup__text">${store.content}</div>
                </div>
            </div>
        `;
        }

        function setActiveStore(storeId) {
            activeStoreId = storeId;

            // Update marker icons
            // FIX #3: Pass marker.options.storeId so each icon keeps its unique clip-path IDs.
            markers.forEach((marker) => {
                const isActive = marker.options.storeId === storeId;
                marker.setIcon(createMarkerIcon(isActive, marker.options.storeId));

                if (isActive) {
                    marker.setZIndexOffset(1000);
                } else {
                    marker.setZIndexOffset(0);
                }
            });

            // Update store list
            updateStoreListActiveState();

            // Pan to marker if active
            if (storeId) {
                const activeMarker = markers.find((m) => m.options.storeId === storeId);
                if (activeMarker) {
                    map.flyTo(activeMarker.getLatLng(), Math.max(map.getZoom(), 12), {
                        duration: CONFIG.flyToDuration,
                    });
                }
            }
        }

        function fitMapToMarkers(filteredMarkers = null) {
            const markersToFit = filteredMarkers || getVisibleMarkers();

            if (markersToFit.length === 0) return;

            // FIX #1: Stop any in-progress flyTo/flyToBounds animation before starting
            // a new one, so competing animations don't cause pins to visually drag.
            map.stop();

            if (markersToFit.length === 1) {
                map.flyTo(markersToFit[0].getLatLng(), 14, {
                    duration: CONFIG.flyToDuration,
                });
            } else {
                const group = L.featureGroup(markersToFit);
                map.flyToBounds(group.getBounds(), {
                    padding: [50, 50],
                    duration: CONFIG.flyToDuration,
                });
            }
        }

        function getVisibleMarkers() {
            return markers.filter((marker) => {
                const store = marker.options.storeData;

                // Region filter
                if (activeRegion !== 'all') {
                    if (!store.region || store.region.slug !== activeRegion) {
                        return false;
                    }
                }

                return true;
            });
        }

        // =========================================================================
        // MAP CONTROLS
        // =========================================================================

        function setupMapControls() {
            const zoomIn = document.getElementById('zoomIn');
            const zoomOut = document.getElementById('zoomOut');
            const resetView = document.getElementById('resetView');

            if (zoomIn) {
                zoomIn.addEventListener('click', () => map.zoomIn());
            }

            if (zoomOut) {
                zoomOut.addEventListener('click', () => map.zoomOut());
            }

            if (resetView) {
                resetView.addEventListener('click', () => {
                    activeRegion = 'all';
                    searchQuery = '';

                    // Reset UI
                    const searchInput = document.getElementById('storeSearch');
                    if (searchInput) searchInput.value = '';

                    const tabs = document.querySelectorAll('.sl-regions__tab');
                    tabs.forEach((tab) => {
                        tab.classList.toggle('is-active', tab.dataset.region === 'all');
                    });

                    filterStores();
                });
            }
        }

        // =========================================================================
        // REGION TABS
        // =========================================================================

        function initRegionTabs() {
            const tabsContainer = document.getElementById('regionTabs');
            if (!tabsContainer) return;

            tabsContainer.addEventListener('click', (e) => {
                const tab = e.target.closest('.sl-regions__tab');
                if (!tab) return;

                // Update active state
                document.querySelectorAll('.sl-regions__tab').forEach((t) => {
                    t.classList.remove('is-active');
                });
                tab.classList.add('is-active');

                // Set active region and filter
                activeRegion = tab.dataset.region;
                filterStores();
            });
        }

        // =========================================================================
        // STORE LIST
        // =========================================================================

        function renderStoreList() {
            const container = document.getElementById('storeList');
            if (!container) return;

            const visibleMarkers = getVisibleMarkers();

            if (visibleMarkers.length === 0) {
                container.innerHTML = `
                <div class="sl-stores__empty">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M8 15s1.5-2 4-2 4 2 4 2"/>
                        <line x1="9" y1="9" x2="9.01" y2="9"/>
                        <line x1="15" y1="9" x2="15.01" y2="9"/>
                    </svg>
                    <p>No stores found</p>
                    <span>Try adjusting your search or filters</span>
                </div>
            `;
                return;
            }

            const storesHTML = visibleMarkers
                .map((marker) => {
                    const store = marker.options.storeData;
                    const isActive = store.id === activeStoreId;

                    // FIX #4: Removed duplicate sl-store-card__locate class from the <li>.
                    // Previously both classes were on the same element, making the click
                    // handler's locate-button check always match and the setActiveStore
                    // branch unreachable.
                    return `
                <li class="sl-store-card${isActive ? ' is-active' : ''}" data-store-id="${store.id}">
                        <h4 class="sl-store-card__title">${store.title}</h4>
                </li>
            `;
                })
                .join('');

            container.innerHTML = storesHTML;

            // FIX #4: Simplified click handler — clicking a store card always calls
            // focusStore (fly to marker + open popup). The old conditional was dead code
            // because sl-store-card__locate was on the <li> itself, so it always matched.
            container.querySelectorAll('.sl-store-card').forEach((card) => {
                card.addEventListener('click', () => {
                    const storeId = parseInt(card.dataset.storeId, 10);
                    focusStore(storeId);
                });
            });
        }

        function updateStoreListActiveState() {
            document.querySelectorAll('.sl-store-card').forEach((card) => {
                const storeId = parseInt(card.dataset.storeId, 10);
                card.classList.toggle('is-active', storeId === activeStoreId);

                if (storeId === activeStoreId) {
                    card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            });
        }

        function focusStore(storeId) {
            const marker = markers.find((m) => m.options.storeId === storeId);
            if (marker) {
                setActiveStore(storeId);
                marker.openPopup();
            }
        }

        // =========================================================================
        // FILTERING
        // =========================================================================

        function filterStores() {
            // Close any open popup before the region transition. Leaving a popup open
            // causes the marker to visually drag when setIcon changes the iconAnchor
            // (active 44px → inactive 36px) while flyToBounds is starting.
            // The popupclose handler on each marker already calls setActiveStore(null),
            // so this also cleans up the active icon and state automatically.
            map.closePopup();

            const visibleMarkers = getVisibleMarkers();

            // Update marker visibility
            markers.forEach((marker) => {
                const isVisible = visibleMarkers.includes(marker);

                if (isVisible) {
                    if (!markerLayer.hasLayer(marker)) {
                        markerLayer.addLayer(marker);
                    }
                } else {
                    markerLayer.removeLayer(marker);
                }
            });

            // Re-render store list
            renderStoreList();

            // FIX #2: Clear the active store BEFORE starting the flyToBounds animation
            // so the map state is clean when fitMapToMarkers fires. Previously this ran
            // after fitMapToMarkers, leaving a stale activeStoreId during the animation.
            if (activeStoreId) {
                const activeStillVisible = visibleMarkers.some((m) => m.options.storeId === activeStoreId);
                if (!activeStillVisible) {
                    setActiveStore(null);
                }
            }

            // Fit map to visible markers
            fitMapToMarkers(visibleMarkers);
        }

        // =========================================================================
        // INITIALIZATION
        // =========================================================================

        function init() {
            // Check for required data
            if (!window.storeLocatorData || !window.storeLocatorData.stores) {
                // console.error('Store Locator: No store data found');
                return;
            }

            // Check for Leaflet
            if (typeof L === 'undefined') {
                // console.error('Store Locator: Leaflet library not loaded');
                return;
            }

            // Initialize components
            initMap();
            initRegionTabs();
            renderStoreList();
            // console.log('Store Locator initialized with', window.storeLocatorData.stores.length, 'stores');
        }

        // Start when DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }

        if ($('body').hasClass('page-template-tmpl_contact')) {
            const mapcon = document.querySelector('#contact_map');
            const coords = JSON.parse(mapcon.dataset.location);
            const iconUrl = mapcon.dataset.icon;
            var maps = L.map(mapcon, {
                center: CONFIG.map.defaultCenter,
                zoom: CONFIG.map.defaultZoom,
                minZoom: CONFIG.map.minZoom,
                maxZoom: CONFIG.map.maxZoom,
                zoomControl: CONFIG.map.zoomControl,
                // dragging: CONFIG.map.dragging,
                // tap: CONFIG.map.tap,
                scrollWheelZoom: CONFIG.map.scrollWheelZoom,
            }).setView(coords, 12);

            var customIcon = L.icon({
                iconUrl: iconUrl,
                iconSize: [38, 95],
            });

            L.tileLayer('https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap contributors',
            }).addTo(maps);

            L.marker(coords, { icon: customIcon }).addTo(maps);
        }
    })();
}

// export function initMap() {
//     const mapStyle = [
//         {
//             "featureType": "all",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "administrative",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 }
//             ]
//         },
//         {
//             "featureType": "administrative",
//             "elementType": "labels.text.fill",
//             "stylers": [
//                 {
//                     "color": "#090909"
//                 },
//                 {
//                     "visibility": "on"
//                 }
//             ]
//         },
//         {
//             "featureType": "administrative.neighborhood",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "landscape",
//             "elementType": "all",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 },
//                 {
//                     "color": "#f9f8f6"
//                 }
//             ]
//         },
//         {
//             "featureType": "landscape",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "poi",
//             "elementType": "all",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "poi",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "poi.park",
//             "elementType": "geometry",
//             "stylers": [
//                 {
//                     "color": "#f9f8f6"
//                 },
//                 {
//                     "visibility": "on"
//                 }
//             ]
//         },
//         {
//             "featureType": "road",
//             "elementType": "all",
//             "stylers": [
//                 {
//                     "saturation": -100
//                 },
//                 {
//                     "lightness": 45
//                 }
//             ]
//         },
//         {
//             "featureType": "road",
//             "elementType": "geometry.fill",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 },
//                 {
//                     "color": "#090909"
//                 }
//             ]
//         },
//         {
//             "featureType": "road",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 }
//             ]
//         },
//         {
//             "featureType": "road",
//             "elementType": "labels.text",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 },
//                 {
//                     "color": "#000000"
//                 }
//             ]
//         },
//         {
//             "featureType": "road",
//             "elementType": "labels.text.fill",
//             "stylers": [
//                 {
//                     "color": "#000000"
//                 }
//             ]
//         },
//         {
//             "featureType": "road",
//             "elementType": "labels.text.stroke",
//             "stylers": [
//                 {
//                     "color": "#ffffff"
//                 }
//             ]
//         },
//         {
//             "featureType": "road.highway",
//             "elementType": "all",
//             "stylers": [
//                 {
//                     "visibility": "simplified"
//                 }
//             ]
//         },
//         {
//             "featureType": "road.highway",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "road.highway",
//             "elementType": "labels.text",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 },
//                 {
//                     "color": "#000000"
//                 }
//             ]
//         },
//         {
//             "featureType": "road.highway",
//             "elementType": "labels.text.stroke",
//             "stylers": [
//                 {
//                     "color": "#ffffff"
//                 }
//             ]
//         },
//         {
//             "featureType": "road.arterial",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 }
//             ]
//         },
//         {
//             "featureType": "road.arterial",
//             "elementType": "labels.text",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 },
//                 {
//                     "color": "#000000"
//                 }
//             ]
//         },
//         {
//             "featureType": "road.arterial",
//             "elementType": "labels.text.stroke",
//             "stylers": [
//                 {
//                     "visibility": "on"
//                 },
//                 {
//                     "color": "#ffffff"
//                 }
//             ]
//         },
//         {
//             "featureType": "road.arterial",
//             "elementType": "labels.icon",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "transit",
//             "elementType": "all",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "transit",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         },
//         {
//             "featureType": "water",
//             "elementType": "all",
//             "stylers": [
//                 {
//                     "color": "#eeebe4"
//                 },
//                 {
//                     "visibility": "on"
//                 }
//             ]
//         },
//         {
//             "featureType": "water",
//             "elementType": "labels",
//             "stylers": [
//                 {
//                     "visibility": "off"
//                 }
//             ]
//         }
//     ];

//     /*id of map here*/
//     if ($("#map").length > 0) {
//         window.addEventListener("load", initializeMap);
//     }

//     async function initializeMap() {
//         const mapCanvas = document.getElementById("map");
//         const coordsDynamic = mapCanvas.getAttribute("data-coords");
//         const splittedCoords = coordsDynamic.split(", ");
//         const myLatLng = new google.maps.LatLng(splittedCoords[0], splittedCoords[1]);

//         const mapOptions = {
//             zoom: 15,
//             gestureHandling: "cooperative",
//             center: myLatLng,
//             mapTypeId: google.maps.MapTypeId.ROADMAP,
//             styles: mapStyle,
//             scrollwheel: false,
//         };

//         const map = new google.maps.Map(mapCanvas, mapOptions);
//         const iconSource =
//             window.location.origin +
//             window.location.pathname.split('/').slice(0, 2).join('/') + // comment this out when going live
//             "/wp-content/themes/ecc/assets/images/marker.png";

//         // As of February 21st, 2024, google.maps.Marker is deprecated.
//         // Please use google.maps.marker.AdvancedMarkerElement instead.
//         // At this time, google.maps.Marker is not scheduled to be discontinued,
//         // but google.maps.marker.AdvancedMarkerElement is recommended over google.maps.Marker.

//         const marker = new google.maps.Marker({
//             map: map,
//             position: myLatLng,
//             icon: {
//                 url: iconSource,
//             },
//         });

//         // While google.maps.Marker will continue to receive bug fixes for any major regressions,
//         // existing bugs in google.maps.Marker will not be addressed.
//         // At least 12 months notice will be given before support is discontinued.

//         marker.setAnimation(google.maps.Animation.BOUNCE);
//         setTimeout(() => {
//             marker.setAnimation(null);
//         }, 1000);
//     }

// }
